import { createClient } from '@supabase/supabase-js';
import { cloudSetupMessage } from './cloudMessage.js';

export { cloudSetupMessage };

const env = import.meta.env || {};
export const supabaseUrl = String(env.VITE_SUPABASE_URL || '').trim();
export const supabaseKey = String(env.VITE_SUPABASE_PUBLISHABLE_KEY || env.VITE_SUPABASE_ANON_KEY || '').trim();
export const isSupabaseConfigured = Boolean(supabaseUrl && supabaseKey);
export const supabase = isSupabaseConfigured ? createClient(supabaseUrl, supabaseKey, {
  auth: { persistSession: true, autoRefreshToken: true, detectSessionInUrl: true },
}) : null;

export function requireSupabase() {
  if (!supabase) throw new Error(cloudSetupMessage());
  return supabase;
}
